<template>
	<v-container class="ma-0 pa-0">
		<v-card flat>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md4 class="pr-3">
						<v-select
							v-model="selectedType"
							:items="certificateTypes"
							item-text="label"
							item-value="value"
							label="Zertifikatstyp"
						></v-select>
					</v-flex>
					<v-flex xs12 md4 class="pr-3">
						<v-menu
							v-model="datePicker"
							:close-on-content-click="false"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
						>
							<v-text-field
								slot="activator"
								v-model="validUntil"
								label="Gültig bis"
								prepend-icon="event"
								readonly
							></v-text-field>
							<v-date-picker
								v-model="validUntil"
								locale="de-CH"
								@input="datePicker = false"
							></v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs12 md4 class="d-flex align-center">
						<input
							style="display: none"
							type="file"
							ref="fileInput"
							accept=".pdf"
							@change="onFileSelected($event.target.files)"
						/>
						<v-btn class="blexon-button ml-0" @click="$refs.fileInput.click()">
							<v-icon class="black--text mr-1">attach_file</v-icon>
							{{ selectedFile ? selectedFile.name : "PDF auswählen" }}
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn class="blexon-button" :loading="isSaving" :disabled="!canSave" @click="save"
					>Speichern</v-btn
				>
			</v-card-actions>
		</v-card>

		<v-divider class="my-3"></v-divider>

		<v-card flat>
			<v-card-title class="subheading font-weight-bold">Vorhandene Zertifikate</v-card-title>
			<v-card-text>
				<v-progress-linear
					v-if="isLoading"
					color="accent"
					indeterminate
				></v-progress-linear>
				<div v-if="!isLoading && certificates.length === 0" class="grey--text">
					Keine Zertifikate vorhanden.
				</div>
				<v-list v-if="certificates.length > 0" dense>
					<v-list-tile
						v-for="cert in certificates"
						:key="cert.id"
						style="cursor: pointer"
						@click="downloadCertificate(cert)"
					>
						<v-list-tile-avatar>
							<v-icon :color="isValid(cert.validUntil) ? 'green' : 'red'"
								>verified_user</v-icon
							>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{
								getCertificateTypeLabel(cert.managementCertificateType)
							}}</v-list-tile-title>
							<v-list-tile-sub-title
								>Gültig bis:
								{{ formatDate(cert.validUntil) }}</v-list-tile-sub-title
							>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon>download</v-icon>
						</v-list-tile-action>
					</v-list-tile>
				</v-list>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {
		fertigerId: Number | String,
	},
	data() {
		return {
			selectedType: 1,
			validUntil: null,
			selectedFile: null,
			datePicker: false,
			isSaving: false,
			isLoading: false,
			certificates: [],
			certificateTypes: [{ label: "ISO 9001", value: 1 }],
		};
	},
	computed: {
		canSave() {
			return (
				this.selectedFile !== null && this.validUntil !== null && this.selectedType !== null
			);
		},
	},
	mounted() {
		this.loadCertificates();
	},
	methods: {
		onFileSelected(files) {
			if (files.length === 1) {
				this.selectedFile = files[0];
			}
		},
		async save() {
			if (!this.canSave) return;
			this.isSaving = true;
			try {
				const data = new FormData();
				data.append("document", this.selectedFile);
				const config = { header: { "Content-Type": "multipart/form-data" } };
				await httpClient().post(
					`api/Fertiger/SaveManagementCertificate?fertigerId=${this.fertigerId}&validUntil=${this.validUntil}&managementCertificateType=${this.selectedType}`,
					data,
					config
				);
				this.selectedFile = null;
				this.validUntil = null;
				this.$refs.fileInput.value = "";
				this.$emit("saved");
				await this.loadCertificates();
			} catch (err) {
				this.$emit("failedToSave");
			} finally {
				this.isSaving = false;
			}
		},
		async loadCertificates() {
			this.isLoading = true;
			try {
				const response = await httpClient().get(
					`api/Fertiger/GetManagementCertificates?fertigerId=${this.fertigerId}`
				);
				this.certificates = response.data;
			} catch (err) {
				console.error("Fehler beim Laden der Zertifikate", err);
			} finally {
				this.isLoading = false;
			}
		},
		getCertificateTypeLabel(type) {
			const found = this.certificateTypes.find((t) => t.value === type);
			return found ? found.label : `Typ ${type}`;
		},
		async downloadCertificate(cert) {
			const response = await httpClient().get(
				`api/Fertiger/DownloadManagementCertificate?certificateId=${cert.id}`,
				{ responseType: "blob" }
			);
			const url = URL.createObjectURL(response.data);
			const a = document.createElement("a");
			a.href = url;
			a.download = `${this.getCertificateTypeLabel(cert.managementCertificateType)}.pdf`;
			a.click();
			URL.revokeObjectURL(url);
		},
		isValid(dateString) {
			return dateString && new Date(dateString) >= new Date();
		},
		formatDate(dateString) {
			if (!dateString) return "";
			const d = new Date(dateString);
			return d.toLocaleDateString("de-CH");
		},
	},
};
</script>
